import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import * as ItemRepairActionType from '../constants';
import { AddProblem } from './add-problem';
// import { Combobox } from 'components/combobox/combobox';
import { Dropdown } from 'components/Dropdown/Dropdown';
import Form from 'components/react-validation/components/form';
import Input from 'components/react-validation/components/input';
import Submit from 'components/react-validation/components/submit';
import * as Vali from 'helper/validator-helper';

export class AddEditItemModal extends Component {
  static propTypes = {
    isCreate: PropTypes.bool,
    isOpen: PropTypes.bool,
    errorMsg: PropTypes.array,
    selectListItemTrades: PropTypes.array,
    onSubmit: PropTypes.func,
    closeModal: PropTypes.func,
    title: PropTypes.string,
    item: PropTypes.object,
    onFetchTrade: PropTypes.func
  }
  constructor(props) {
    super(props);
    this.state = {
      problems: [],
      tradeValue: props.isCreate ? null : {
        value: props.item.tradeId,
        text: props.item.tradeName,
        extensionValue: null,
        selected: false
      },
      name: props.isCreate ? '' : props.item.description,
      isFetchedTrade: false
    };

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMsg.length) {
      if (isArray(nextProps.errorMsg)) {
        if (this.form) {
          this.form.showError(this.refs['description'], nextProps.errorMsg[0].error);
        }

        // this.setState({ errorMessage: nextProps.errorMsg[0].error });
      } else {
        // this.setState({ errorMessage: nextProps.errorMsg.error });
        if (this.form) {
          this.form.showError(this.refs['description'], nextProps.errorMsg.error);
        }
      }

    }
  }

  mapParam() {
    let param = this.form.getValues();
    if (this.props.isCreate) {
      let problems = [];
      this.problem.state.problems.forEach(item => {
        problems.push(item.text);
      });

      param['problems'] = problems;
    }
    // param['description'] = this.state.name;
    param['tradeId'] = this.state.tradeValue.value;

    if (this.refs.id.value) {
      param['id'] = this.refs.id.value;
    }

    return param;
  }

  onChangeTrade = (event) => {
    this.setState({
      tradeValue: event.value
    });
  }

  fetchTrade = () => {
    this.props.onFetchTrade();
    this.setState({ isFetchedTrade: true });
  }

  onSubmit = (e) => {
    e.preventDefault();
    const combobox = this.combobox.validate();

    if (!combobox) {
      return false;
    }

    if (this.props.isCreate) {
      this.props.onSubmit(e,
        this.mapParam(),
        ItemRepairActionType.CREATE_ITEM_REPAIR_ASYNC);
    } else {
      this.props.onSubmit(e,
        this.mapParam(),
        ItemRepairActionType.UPDATE_ITEM_REPAIR_ASYNC);
    }

    return false;
  }

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onSubmit(e);
    }
  }

  renderAddProblem() {
    if (this.props.isCreate) {
      return <AddProblem ref={c => { this.problem = c; }} />;
    }
    return null;
  }

  handleChangeName = (e) => {
    this.setState({
      name: e.target.value
    });
  }

  closeModal = (e) => {
    this.props.closeModal(e);
  }

  render() {
    const disabled = !this.state.tradeValue;
    let { description } = this.props.item;
    if (this.form) {
      description = this.form.getValues().description;
    }
    return (
      <div className=''>
        <Modal show={this.props.isOpen}>
          <Modal.Header>
            <Modal.Title id='contained-modal-title-lg'>{this.props.title}</Modal.Title>
            <button className='close' onClick={this.closeModal} >&times;</button>
          </Modal.Header>
          <Form ref={ref => {this.form = ref;}} onSubmit={this.onSubmit}>

            <Modal.Body>
              <input type='hidden' name='id' ref='id' value={this.props.item.id} />
              <input type='hidden' name='isActive' ref='isActive' value={this.props.item.isActive} />
              <div className='form-group'>
                <label>Trade <strong className='text-danger'>*</strong></label>
                <Dropdown
                  onChange={this.onChangeTrade}
                  className='filestring-dropdown filter-dropdown'
                  value={this.state.tradeValue}
                  options={this.state.isFetchedTrade ? this.props.selectListItemTrades : [{...this.state.tradeValue}]}
                  onRemote={this.fetchTrade}
                  style={{width: '100%'}}
                  optionLabel='text'
                  filter={true}
                  placeholder='Select a trade'
                  errorMessage='This information is required.'
                  ref={ref => {
                    this.combobox = ref;
                  }} />
              </div>
              <div className='form-group'>
                <label>Name <strong className='text-danger'>*</strong></label>
                <Input type='text'
                  name='description'
                  ref='description'
                  className='form-control'
                  autoFocus
                  max='100'
                  value={description}
                  maxLength='100'
                  validations={[Vali.required, Vali.maxlength]}
                />
              </div>
              {this.renderAddProblem()}
            </Modal.Body>
            <Modal.Footer >
              <Submit className='btn btn-primary btn-siteone' disabled={disabled} onClick={this.onSubmit}>Done</Submit>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/Items/Components/add-edit-item-modal.js